import { gql } from '@apollo/client';

export default gql`
  mutation selectPlan($id: ID!) {
    selectPlan(input: { id: $id }) {
      paymentUrl
    }
  }
`;
